import React from 'react';
import { Box, Button, useTheme } from '@mui/material';

const ViewItineraryButton = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Box style={{ marginLeft: '1vw', width: '95%', marginTop: '3vh' }}>
      <Button
        onClick={onClick}
        sx={{
          width: '100%',
          backgroundColor: '#fff',
          border: '2px solid #000',
          borderRadius: '8px',
          color: '#000',
          fontWeight: 700,
          fontSize: '1rem',
          '&:hover': {
            color: theme.text1 || '#fff',
            bgcolor: theme.primary,
            border: `2px solid ${theme.primary}`,
          },
        }}
      >
        Ver Itinerario
      </Button>
    </Box>
  );
};

export default ViewItineraryButton;
